import { createFileRoute } from "@tanstack/react-router";

import { legalFacts } from "@/features/legal/utils/legal-facts";
import { LegalDocumentPage } from "@/features/legal/components/legal-page";
import { pageMeta } from "@/lib/seo";
import { m } from "@/paraglide/messages.js";

export const Route = createFileRoute("/(public)/cookies/")({
  // Out of search until `legalEntity` holds the real company details.
  staticData: { sitemap: false },
  head: () => ({ meta: pageMeta({ title: m.legal_cookies_title(), description: m.legal_cookies_description() }) }),
  loader: () => ({ crumb: m.footer_cookies() }),
  component: () => <LegalDocumentPage title={m.legal_cookies_title()} source={m.legal_cookies_body(legalFacts())} />,
});
